import Vue from 'vue'
import ServiceApp from '../component/ServiceApplication/ServiceApp'

import '../../../scss/app/service_application.scss'

new Vue({
  el: document.getElementById('js-service-app'),
  components: {
    ServiceApp,
  },
})
